import '../assets/css/product-card.css';

import { Link } from 'react-router-dom';
import { Price , W_Time} from '../../assets/icones/icones';
import React, {Fragment} from "react";
import {FormatNumberByhkh} from "../../clientconfigwebapp";

const ProductCard = (props) => {


    let link_post_get="/" + props.link_to;
    link_post_get=link_post_get.replaceAll("//","")



    return (
        <Fragment>
            <div className='flexColBetStart course-card'>
                <div className='course-img'>
                <span className='flexRowBetCenter'>
                    <W_Time />
                    {props.data_full_curent_item.training_hours}
                </span>
                    <Link   to={link_post_get}>
                    <img className={"img-post-card"} src={props.data_full_curent_item.image_src} alt={props.data_full_curent_item.title_post} />
                    </Link>
                </div>

                <div style={{"paddingRight":"5px","paddingLeft":"5px","width":"100%"}}>

                    <Link  className={"course-card-title"} to={link_post_get}>{props.data_full_curent_item.title_post}</Link>
                    <p className={"summeary_text_cardbox contentdotline contentdotline-3"}>{props.data_full_curent_item.summary_text}</p>
                </div>
                <div className='flexRowBetCenter course-footer'>
                    { props.free ?
                        <Fragment>
                            <span className='free-lable'>رایگان</span>
                        </Fragment>
                        :
                        <Fragment>
                    <span className='flexRowStartCenter' style={{
                        "display": "flex",
                        "flexDirection": "column",
                        "justifyContent": "center",
                        "alignItems": "center",
                        "alignContent": "center",
                        "flexWrap": "wrap"
                    }}>



                        {String(props.data_full_curent_item.price_line).length > 0 ?
                            <Fragment>
                                <del style={{"fontSize":"12px","marginBottom":"4px","color":"#a49a9a"}}> {FormatNumberByhkh(String(props.data_full_curent_item.price_line), ".", ",", "no")}
                                    <span style={{
                                        "paddingRight": "3px",
                                        "fontSize": "11px",
                                        "color": "#767676"
                                    }}>تومان</span></del>
                            </Fragment>
                            :
                            <Fragment></Fragment>
                        }

                        <div> {FormatNumberByhkh(String(props.data_full_curent_item.price), ".", ",", "no")} <span
                            style={{"paddingRight": "3px", "fontSize": "11px", "color": "#767676"}}>تومان</span></div>

                    </span>
                        </Fragment>
                    }
                    <Link to={link_post_get}>اطلاعات بیشتر و خرید</Link>
                </div>
            </div>
        </Fragment>
    );
}

export default ProductCard;